<template>
  <div class="ForgotPass">
    <v-container>
      <v-row justify="center" class="center">
        <v-col
        col=12
        sm="8"
        md="6"
        lg="4"
        xl="3"
        >
          <v-row>
            <v-col cols="12 pb-0 pt-0 pt-sm-6 pb-sm-6">
              <div class="secondary--text text-uppercase text-h4 text-sm-h2 text-lg-h3 text-center">
                <span class="font-weight-medium font-italic font-bold">Rapid</span>
                <span> Quote</span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="secondary--text text-uppercase text-sm-h6 text-center font-weight-light">
                it’s all about the data
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-form>
                <v-card class="primary">
                  <v-card-text>
                    <v-container>
                      <v-row justify="center">
                        <v-col cols="12">
                          <div class="headline secondary--text text-h5 text-md-h4 text-lg-h4 font-weight-regular text-center">Forgot Password?</div>
                        </v-col>
                        <v-col cols="12">
                          <div class="secondary--text text-md-subtitle-1 text-xs-subtitle-2 text-center">We'll email you a code you can use to create a new password.</div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" >
                          <v-text-field 
                            color="secondary"
                            dark
                            v-model="email"
                            label="Email" 
                            :error-messages="emailErrors"
                            required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-btn color="secondary primary--text" class="mr-4" block large @click="submit">
                          Send Code
                          </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-container>
                    <v-row justify="center">
                      <v-col cols="12">
                        <v-btn color="light-blue lighten-1" block text to="/" class="mr-4">back to login</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
  import { validationMixin } from 'vuelidate';
  import { required, email} from 'vuelidate/lib/validators';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    mixins: [validationMixin],
    
    data: () => ({
      email: '',
    }),

    validations: {
      email: { required, email },
    },
    
    computed: {
      ...mapGetters ({
        loginContext: 'loginContext'
      }),
      emailErrors () {
        let errors = [];
        if (!this.$v.email.$dirty) return errors;
        !this.$v.email.email && errors.push('Must be valid e-mail.');
        !this.$v.email.required && errors.push('E-mail is required.');
        return errors;
      },
    },

    methods: {
      ...mapActions(['resetPass']),
      submit () {
        if (this.email === '') return;
        // this.$v.$touch();
        let authData = {
          email: this.email,
        };
        this.resetPass(authData);
      },
    },
  };
</script>

<style scoped>
    .center {
      margin-top:1vh;
    }
    .ForgotPass {
      background: radial-gradient(#505CBE, #282E5F);
      height: 100vh;
    }
</style>